define(["require", "exports", "tslib", "jwt-decode"], function (require, exports, tslib_1, jwt_decode_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.isTokenOlderThan = exports.isTokenExpired = exports.getTokenExpirationDate = exports.decodeJwt = void 0;
    jwt_decode_1 = tslib_1.__importDefault(jwt_decode_1);
    function decodeJwt(token) {
        let decoded = (0, jwt_decode_1.default)(token);
        for (let k in decoded) {
            if (k == "nameid") {
                decoded.id = decoded.username = decoded[k];
            }
            else if (k.indexOf("userdata") > -1) {
                decoded.userData = JSON.parse(decoded[k]);
            }
            else if (k.indexOf("role") > -1) {
                decoded.roles = decoded[k];
            }
        }
        return decoded;
    }
    exports.decodeJwt = decodeJwt;
    function getTokenExpirationDate(token) {
        const decoded = (0, jwt_decode_1.default)(token);
        if (!decoded.exp) {
            return null;
        }
        const date = new Date(0);
        date.setUTCSeconds(decoded.exp);
        return date;
    }
    exports.getTokenExpirationDate = getTokenExpirationDate;
    function isTokenExpired(token) {
        const date = getTokenExpirationDate(token);
        const offsetSeconds = 0;
        if (date === null) {
            return false;
        }
        return !(date.valueOf() > new Date().valueOf() + offsetSeconds * 1000);
    }
    exports.isTokenExpired = isTokenExpired;
    function isTokenOlderThan(token, seconds) {
        if (!token) {
            return false;
        }
        const date = getTokenExpirationDate(token);
        const offsetMs = seconds * 1000;
        if (date === null) {
            return false;
        }
        const than = new Date().valueOf() + offsetMs;
        console.log("Token older than", seconds, " = ", date, new Date().valueOf(), date.valueOf() > than);
        return date.valueOf() > than;
    }
    exports.isTokenOlderThan = isTokenOlderThan;
});
